import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import PriceDrop from '@/assets/icons/price-drop.svg?react';
import { formatCurrency } from '@/helpers/formatters';

const StyledPriceDrop = styled(PriceDrop)(({ theme }) => ({
  '.kmx-car-tile--unavailable & path': {
    fill: theme.palette.action.disabledBackground,
  },
}));

const OriginalPrice = styled(Typography)(({ theme }) => ({
  textDecoration: 'line-through',

  '.kmx-car-tile--unavailable &': {
    color: theme.palette.text.disabled,
  },
}));

type PriceAndMileageProps = {
  price: number;
  mileage: number;
  hasPriceDrop: boolean | undefined;
  originalPrice?: number | null;
};

const PriceAndMileage = ({
  price,
  mileage,
  originalPrice,
  hasPriceDrop,
}: PriceAndMileageProps) => {
  const formattedPrice = price ? `${formatCurrency(price)}*` : 'N/A';
  const formattedOriginalPrice =
    hasPriceDrop && originalPrice ? formatCurrency(originalPrice) : null;
  const roundedMileage = Math.ceil(mileage / 1000);
  const visibleMileage = `${roundedMileage}K mi`;

  return (
    <Stack
      direction="row"
      spacing={1}
      divider={<Divider orientation="vertical" flexItem />}
      className="kmx-car-tile__price-and-mileage"
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.25}
        className={['price-info', hasPriceDrop ? 'has-price-drop' : '']
          .filter(Boolean)
          .join(' ')}
      >
        {hasPriceDrop && (
          <StyledPriceDrop className="price-drop-icon" height={16} />
        )}

        <Typography variant="h6" component="span" fontSize={20}>
          {formattedPrice}
        </Typography>

        {formattedOriginalPrice && (
          <OriginalPrice variant="caption" color="textSecondary">
            {formattedOriginalPrice}
          </OriginalPrice>
        )}
      </Stack>

      <Typography
        variant="h6"
        component="span"
        fontSize={20}
        className="mileage-info"
      >
        {visibleMileage}
      </Typography>
    </Stack>
  );
};

export default PriceAndMileage;
